module.exports = __webpack_public_path__ + "static/media/team_clock_logo_v3_01.ad4e79b4.png";